import { addIndex, equals, isNil, map, pipe, prop } from 'ramda';
import { v4 as uuidv4 } from 'uuid';

const mapIndexed = addIndex(map);
const ORGANIZATIONAL_CHART_GO_TO = 'job-supply-organization-chart';

const prevIsCompleted = (currentIndex, supplies) => {
	if (currentIndex === 0) return true;
	const prev = prop(currentIndex - 1, supplies);
	if (!isNil(prev)) {
		return pipe(prop('status'), val => !!val)(prev);
	}
	return false;
};

export const parseSupplies = supplies => mapIndexed(
	(supply, index) => ({
		id: uuidv4(),
		name: prop('title', supply),
		urlImage: prop('urlImage', supply),
		completed: pipe(prop('status'), val => !!val)(supply),
		enabled: prevIsCompleted(index, supplies),
		description: prop('description', supply),
		instructions: prop('instructions', supply),
		goTo: prop('goTo', supply),
		readOnly: (() => equals(ORGANIZATIONAL_CHART_GO_TO, prop('goTo', supply)))(),
	}),
	supplies,
);

export default {};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/utils/supplies/supplies.js